module.exports = __webpack_public_path__ + "media/images/star-half-1fe4cd87f1f323a45548609343c1aa1a.png";